import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() => ({
  content: ({ hideHeader }) => ({
    margin: hideHeader ? '0 auto' : '12px auto',
    maxWidth: '644px',
    width: '100%',
  }),
}));

export default useStyles;
